import React from "react";
import { Alert, Typography, Box, useMediaQuery, useTheme, Chip } from "@mui/material";
import dayjs from "dayjs";
import ShadowBox from "../container/ShadowBox";
import SimpleBox from "../container/SimpleBox";
import RequestIconButton from "../../input/button/RequestIconButton";
import DialogRequest from "../../dialog/DialogRequest";
import AddButton from "../../input/button/AddButton";
import { useNavigate } from "react-router";

const PersonRequests = ({ requests = [] }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [selectedRequest, setSelectedRequest] = React.useState(null);
    const requestOpen = Boolean(selectedRequest);

    const getTopicLabel = (topic) => {
        const topicMap = { EDIT: "Atualização", NEW: "Novo" };
        const topicLabel = (topicMap[topic] ?? topic).toUpperCase();
        return topicLabel;
    }

    return (
        <ShadowBox title="Pedidos em Curso" titleVariant="h3" mt={6}>
            {
                requests.length === 0 ? (
                    <Alert severity="info">Não existem pedidos em curso.</Alert>
                ) : (
                    requests.map((req, index) => {
                        return (
                            <SimpleBox
                                key={index}
                                fullWidth={true}
                                gap={2}
                                backgroundColor={`whiteSmoke.${index % 2 === 0 ? "light" : "dark"}`}
                                padding={2}
                                flexDirection={isMobile ? "column" : "row"}
                            >
                                <SimpleBox gap={2}>
                                    <Typography fontWeight="bold">{req.fullName}</Typography>
                                    <Chip sx={{ fontSize: "0.6rem" }} label={getTopicLabel(req.topic)} size="small" color="saffron" />
                                </SimpleBox>
                                <SimpleBox gap={4}>
                                    <Typography>{dayjs(req.createdAt).format("DD MMM YY HH:mm")}</Typography>
                                    <RequestIconButton onClick={() => setSelectedRequest(req)} />
                                </SimpleBox>
                            </SimpleBox>
                        )
                    })
                )
            }
            <Box mt={2} width="100%" textAlign="right">
                <AddButton label="Novo Sócio" onClick={() => navigate(`/edit-member/NEW/null`) } />
            </Box>
            <DialogRequest open={requestOpen} request={selectedRequest} closeMethod={() => setSelectedRequest(null)} />
        </ShadowBox>
    )
}

export default PersonRequests;
